export const paginationData = (totalPages) => {
    if (totalPages) {
      if (totalPages <= 5) {
            return Array.from({ length: totalPages })
                ?.fill("_")
                .map((_, index) => index + 1);
        }
        if (totalPages > 5) {
            return [
                1,
                2,
                3,
                "...",
                totalPages - 2,
                totalPages - 1,
                totalPages,
            ];
        }
    }
  return [1];
}